/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preset_Save_AbortedInputs */



/**
* | output |
* | --- |
* | "Save preset aborted." |
*
* @param {Video_Export_Preset_Save_AbortedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preset_save_aborted = /** @type {((inputs?: Video_Export_Preset_Save_AbortedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preset_Save_AbortedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement du prereglage annule.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speichern der Voreinstellung abgebrochen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvataggio predefinito interrotto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранение настроек прервано.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se interrumpió el guardado del ajuste preestablecido.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存预设已中止。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットの保存が中止されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीसेट सेव करने की प्रक्रिया रद्द कर दी गई।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvamento da predefinição cancelado.")
	return /** @type {LocalizedString} */ ("Save preset aborted.")
});